/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import ActionCable from 'actioncable';
import Toastr from 'toastr/toastr';

import 'n2-styles/dist/js/n2-styles-turbolinks.min';
import 'n2-styles/dist/js/vendors.min';

import { N2Ready, N2Unload } from '../src/javascript/components/N2';

import '../src/javascript/components/eventListeners';
import './images';

import ControllerLoader from '../src/javascript/components/ControllerLoader';

import 'src/javascript/components/flipbook'

window.toastr = Toastr;

Rails.start();
Turbolinks.start();

N2Ready((eve) => {
  ControllerLoader.load(eve);
});

N2Unload((eve) => {
  ControllerLoader.unload(eve);
});
